<script lang="ts">
    import { type Snippet, untrack } from 'svelte';
    import Esi from '@shared/components/esi/Esi.svelte';
    import {
        type ComparisonContext,
        setComparisonContext,
    } from '@shared/providers/comparison-context/ComparisonContext.browser.ts';
    import type { Variation, VariationV2 } from '@shared/types/types.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import { PandaComparison } from '@tilelist/components/product-comparison/PandaComparison.ts';

    interface Props {
        comparisonId?: string;
        children: Snippet;
    }

    const { comparisonId, children }: Props = $props();

    const wiring = injectWiring();

    const comparisonState = $state<ComparisonContext>({
        get comparisonId() {
            return comparisonId || null;
        },
        initialized: false,
        showComparison: false,
        selectedVariations: [],
        compareLink: null,
        async selectVariation(variation: Variation | VariationV2) {
            await pandaComparison.selectVariation(comparisonState, variation);
        },
        async deselectVariation(id: string) {
            await pandaComparison.deselectVariation(comparisonState, id);
        },
        async clearSelectedVariations() {
            await pandaComparison.clearSelectedVariations(comparisonState);
        },
    });
    setComparisonContext(comparisonState);

    /*               */
    let pandaComparison: PandaComparison;

    /**
 *
 *
 */
    let lastComparisonId = $state(untrack(() => comparisonId));
    $effect(() => {
        if (!comparisonId) return;

        if (!pandaComparison && wiring.variationLoadingService && wiring.trackingService && wiring.eventsIncoming) {
            pandaComparison = new PandaComparison(
                wiring.variationLoadingService,
                wiring.trackingService,
                wiring.eventsIncoming,
            );
            pandaComparison.initialize(comparisonState);
        }
        if (comparisonId !== lastComparisonId) {
            pandaComparison.updateContext(comparisonState);
            lastComparisonId = comparisonId;
        }
    });
</script>

<Esi src="/dcs/product-comparison-api" />

{@render children()}
